<template>

	<v-text-field
		ref="inputField"
		:label="field.template.name"
		v-model="field.value"
		outlined
		dense
		validate-on-blur
		:rules="agile.fieldRules.numberRule"
		style="max-width: 180px;"
		class="ai-align-right"
	></v-text-field>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";


export default
{
	name: 'ContentFieldNumber',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		value: '',
	}),

	computed:
	{
        agile()
        {
            return agile;
		},
	},


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		
		this.field.value = this.field.template.typeProperties.defaultValue;

		if (this.field.data)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
			}
			
		}
		
	},

	mounted()
	{
		this.$refs.inputField.$el.addEventListener("input", this.validateKey);
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		validateKey()
		{
			const inputElement = this.$refs.inputField.$el.getElementsByTagName("input")[0];
			let v = inputElement.value;

			if (v.includes('-')) v = '-'+v.replace(/-/g, '');
			v = v.toString().replace(/[^0-9-,.]+/g, '');
			v = v.replace(',', '.');
			v = v.split('.');
			v = v.shift() + (v.length ? '.' + v.join('') : '');

			inputElement.value = v;
			this.field.value = v;


		},
		
	},


	beforeDestroy()
	{
		this.$refs.inputField.$el.removeEventListener("input", this.validateKey);
	},

}

</script>

